import { makeAutoObservable, toJS } from "mobx";
import { EMPTY_ACCOUNT } from "../defaults/account";
import { EMPTY_MEMBER } from "../defaults/member";
import { DEFAULT_RECORDS_LIMIT } from "../defaults/records-limit";
import { EMPTY_SOLUTION } from "../defaults/solution";
import { EMPTY_USER_PREFERENCES } from "../defaults/user-preferences";
import type { Account } from "../types/account.model";
import type { Member } from "../types/member";
import type { Solution } from "../types/solution";
import type { UserPreferences } from "../types/user-preferences";

export enum ImportType {
  application = "application",
  solution = "solution",
}

export const DEFAULT_IMPORT_TYPE = ImportType.application;

export class ConfigStore {
  public accountId: string = "";
  public role: string = "";
  public solutionId: string = "";
  public accessToken: string | undefined;
  public smartsuiteBackendUrl: string = "";
  public userPreferences: UserPreferences = EMPTY_USER_PREFERENCES;
  public solution: Solution = EMPTY_SOLUTION;
  public member: Member = EMPTY_MEMBER;
  public account: Account = EMPTY_ACCOUNT;
  public recordsLimit: number = DEFAULT_RECORDS_LIMIT;
  public importType: ImportType | undefined = DEFAULT_IMPORT_TYPE;
  public featureFlags: Record<string, boolean> = {};

  constructor() {
    makeAutoObservable(this);
  }

  init(
    accountId: string,
    role: string,
    solutionId: string,
    accessToken: string | undefined,
    smartsuiteBackendUrl: string,
    userPreferences: UserPreferences,
    solution: Solution,
    member: Member,
    account: Account,
    recordsLimit: number,
    featureFlags: Record<string, boolean>,
  ): void {
    this.accountId = accountId;
    this.role = role;
    this.solutionId = solutionId;
    this.accessToken = accessToken;
    this.smartsuiteBackendUrl = smartsuiteBackendUrl;
    this.userPreferences = userPreferences;
    this.solution = toJS(solution);
    this.member = member;
    this.account = account;
    this.recordsLimit = recordsLimit;
    this.featureFlags = featureFlags;
  }

  setImportType(importType: ImportType): void {
    this.importType = importType;
  }
}
